import { render, staticRenderFns } from "./InvoicesLayout.vue?vue&type=template&id=52512328&scoped=true"
import script from "./InvoicesLayout.vue?vue&type=script&lang=js"
export * from "./InvoicesLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52512328",
  null
  
)

export default component.exports